import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

/**
 * SWIPER モジュール
 * - .js-swiper-hero 内の .swiper をフェードエフェクト付きで自動スライド
 */
export const SWIPER = {
  init() {
    const loop = document.querySelector('.js-swiper-loop')
    if (loop) {
      const swiper = loop.querySelector('.swiper')
      const slides = swiper?.querySelectorAll('.swiper-slide')

      if (swiper && slides?.length) {
        /* eslint-disable no-unused-vars */

        const loopSwiper = new Swiper(swiper, {
          slidesPerView: 'auto',
          spaceBetween: 6,
          loop: true,
          loopedSlides: slides.length,
          loopAdditionalSlides: slides.length,
          loopedSlidesLimit: false,
          speed: 8000,
          allowTouchMove: false,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
          breakpoints: {
            768: {
              spaceBetween: 12,
            },
          },
        })

        /* eslint-enable no-unused-vars */
      }
    }

    const archives = document.querySelectorAll('.js-swiper-archive')

    if (archives.length) {
      archives.forEach(archive => {
        const swiper = archive.querySelector('.swiper')
        const wrapper = swiper?.querySelector('.swiper-wrapper')
        const slides = swiper?.querySelectorAll('.swiper-slide')

        if (!swiper || !wrapper || !slides.length) {
          return
        }

        const slidesWidth = Array.from(slides).reduce((total, slide, index) => {
          const spaceBetween = index < slides.length - 1 ? 12 : 0

          return total + slide.getBoundingClientRect().width + spaceBetween
        }, 0)

        const isLoop = slidesWidth > swiper.clientWidth

        /* eslint-disable no-unused-vars */
        const archivesSwiper = new Swiper(swiper, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          loop: isLoop,
          speed: 600,
          watchOverflow: true,
        })
        /* eslint-enable no-unused-vars */
      })
    }

    const pickup = document.querySelectorAll('.js-swiper-pickup')

    if (pickup.length) {
      pickup.forEach(item => {
        const swiper = item.querySelector('.swiper')
        const wrapper = swiper?.querySelector('.swiper-wrapper')
        const slides = swiper?.querySelectorAll('.swiper-slide')

        if (!swiper || !wrapper || !slides.length) {
          return
        }

        const spaceBetween = item.closest('.l-sidebar') ? 8 : 24

        const slidesWidth = Array.from(slides).reduce((total, slide, index) => {
          const gap = index < slides.length - 1 ? spaceBetween : 0

          return total + slide.getBoundingClientRect().width + gap
        }, 0)

        // スライド合計幅がコンテナを超える場合のみループ有効（初期位置は左端）
        const isOverflow = slidesWidth > swiper.clientWidth

        /* eslint-disable no-unused-vars */
        const pickupSwiper = new Swiper(swiper, {
          centeredSlides: true,
          slidesPerView: 'auto',
          spaceBetween: 12,
          speed: 600,
          loop: isOverflow,
          initialSlide: 0,
          loopedSlides: slides.length,
          watchOverflow: true,
          pagination: {
            el: item.querySelector('.swiper-pagination'),
            clickable: true,
          },
          breakpoints: {
            768: {
              centeredSlides: false,
              spaceBetween,
            },
          },
        })
        /* eslint-enable no-unused-vars */
      })
    }

    const areamap = document.querySelectorAll('.js-swiper-areamap')

    if (areamap.length) {
      areamap.forEach(item => {
        const swiper = item.querySelector('.swiper')
        const wrapper = swiper?.querySelector('.swiper-wrapper')
        const slides = swiper?.querySelectorAll('.swiper-slide')

        if (!swiper || !wrapper || slides.length <= 1) {
          return
        }

        /* eslint-disable no-unused-vars */
        const areamapSwiper = new Swiper(swiper, {
          slidesPerView: 'auto',
          spaceBetween: 0,
          loop: true,
          speed: 600,
          watchOverflow: true,
        })
        /* eslint-enable no-unused-vars */
      })
    }
  },
}
